module.exports = __webpack_public_path__ + "static/03-c2167fba8df4d712d8911975b1a3c849.jpg";